import { render, staticRenderFns } from "./AddAternityModal.vue?vue&type=template&id=94090224&"
import script from "./AddAternityModal.vue?vue&type=script&lang=js&"
export * from "./AddAternityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports